<template>
  <section class="section">
    <div class="container">
      {{ status_provere }}
    </div>
  </section>
</template>

<script>
import PaymentService from '../services/PlacanjeService'

export default {
  data() {
    return {
      status_provere: 'Провера статуса трансакције у току ...'
    }
  },
  created() {
    // debugger
    let checkoutId = this.$route.query.id
    if (checkoutId) {
      PaymentService.savePaymentStatus(checkoutId)
        .then(response => {
          var n = response.data.podaci.narudzbina
          console.log(n)
          if (response.data.status === 'OK') {
            this.$router.push({
              name: 'PlacanjeStatus',
              query: { checkoutId: checkoutId },
              params: { narudzbina: n }
            })
          }
        })
        .catch(error => {
          this.status_provere = 'Дошло је до грешке!'
          console.log(error)
        })
    } else {
      this.status_provere = 'Дошло је до грешке!'
      console.log('Nepoznat checkoutId')
    }
  }
}
</script>

<style></style>
